import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import useWindowSize from '../../hooks/useWindowSize.js';
import determineButtonText from '../../utils/determineButtonText.js';
import Typography from '../Typography/index.js';
import { Button as Button$2 } from './Button.styles.js';

var _excluded = ["children", "variant", "type", "color", "rounded", "shadow", "outlined", "ghost", "gradient", "leftIcon", "rightIcon", "mobileText", "visibility"];
var Button = function Button(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? null : _ref$variant,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? 'min' : _ref$rounded,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? true : _ref$shadow,
    _ref$outlined = _ref.outlined,
    outlined = _ref$outlined === void 0 ? false : _ref$outlined,
    _ref$ghost = _ref.ghost,
    ghost = _ref$ghost === void 0 ? false : _ref$ghost,
    _ref$gradient = _ref.gradient,
    gradient = _ref$gradient === void 0 ? false : _ref$gradient,
    _ref$leftIcon = _ref.leftIcon,
    leftIcon = _ref$leftIcon === void 0 ? null : _ref$leftIcon,
    _ref$rightIcon = _ref.rightIcon,
    rightIcon = _ref$rightIcon === void 0 ? null : _ref$rightIcon,
    _ref$mobileText = _ref.mobileText,
    mobileText = _ref$mobileText === void 0 ? null : _ref$mobileText,
    visibility = _ref.visibility,
    props = _objectWithoutProperties(_ref, _excluded);
  var windowSize = useWindowSize();
  var buttonText = determineButtonText(windowSize === null || windowSize === void 0 ? void 0 : windowSize.width, mobileText, children);
  var textVariant = null;
  if (variant === 'small') {
    textVariant = 'small';
  } else if (variant === 'feature') {
    textVariant = 'feature';
  } else if (variant === 'hero') {
    textVariant = 'h5';
  } else if (variant === 'mega') {
    textVariant = 'feature';
  }
  return /*#__PURE__*/React.createElement(Button$2, _extends({
    className: "leshen-button leshen-button-".concat(variant),
    variant: variant,
    leftIcon: leftIcon,
    rightIcon: rightIcon,
    gradient: gradient,
    color: color,
    ghost: ghost,
    tabIndex: "0",
    rounded: rounded,
    shadow: shadow,
    outlined: outlined,
    type: type,
    visibility: visibility
  }, props), leftIcon, buttonText && /*#__PURE__*/React.createElement(Typography, {
    className: "button-text",
    variant: textVariant,
    rendersAs: "span"
  }, buttonText), rightIcon);
};
var Button$1 = Button;

export { Button$1 as default };
//# sourceMappingURL=index.js.map
